import React from "react";
import { Box, Typography } from "@mui/material";
import { ACCENT, text } from "../theme";
import { relativeTime } from "../utils/date";

interface Props {
  total: number;
  lastUpdated: Date | null;
}

/**
 * Masthead. Search, refresh and the source filter live in ControlBar so they
 * can pin to the top of the viewport; this scrolls away with the content.
 */
export function Header({ total, lastUpdated }: Props) {
  return (
    <Box component="header" sx={{ pb: 2 }}>
      <Typography component="h1" variant="h1" sx={{ color: text.primary }}>
        Tez<Box component="span" sx={{ color: ACCENT }}>Lens</Box>
      </Typography>
      <Typography variant="caption" sx={{ color: text.tertiary }}>
        {total > 0
          ? `${total.toLocaleString()} stories from across the Tezos ecosystem`
          : "News from across the Tezos ecosystem"}
        {lastUpdated && ` · updated ${relativeTime(lastUpdated.toISOString())}`}
      </Typography>
    </Box>
  );
}
